<template>
  <b-table responsive striped hover :fields="fields" :items="data">
    <template #cell(person)="data">
      {{ data.index + 1 }}
    </template>
    <template #cell(personDamageType)="data">
      {{
        data.item.personDamageType
          ? $i18n.t("avalanche.personDamageType." + data.item.personDamageType)
          : null
      }}
    </template>
    <template #cell(burialType)="data">
      {{
        data.item.burialType
          ? $i18n.t("avalanche.burialType." + data.item.burialType)
          : null
      }}
    </template>
    <template #cell(delete)="data">
      <b-button @click="removeItem(data.index)">
        <i class="fas fa-trash"> </i>
      </b-button>
    </template>
  </b-table>
</template>
<script>
export default {
  data() {
    return {
      fields: [
        {
          key: "person",
          label: this.$i18n.t("avalanche.label.damage.person"),
        },
        {
          key: "personDamageType",
          label: this.$i18n.t("avalanche.label.damage.personDamageType"),
        },
        {
          key: "burialType",
          label: this.$i18n.t("avalanche.label.damage.burialType"),
        },
        {
          key: "burialPeriod",
          label: this.$i18n.t("avalanche.label.damage.burialPeriod"),
        },
        {
          key: "burialDepth",
          label: this.$i18n.t("avalanche.label.damage.burialDepth"),
        },
        {
          key: "delete",
          label: this.$i18n.t("ui.delete"),
        },
      ],
    };
  },
  props: { victims: Array },
  computed: {
    data() {
      return this.victims;
    },
  },
  methods: {
    removeItem(index) {
      this.$emit("removeVictim", index);
    },
  },
};
</script>

<style></style>
